var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web",
    transform: "translate(0.467 -0.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_322",
    "data-name": "Ellipse 322",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(-0.467 0.4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "internet",
    d: "M20.485,3.515A11.921,11.921,0,0,0,12,0h0A12,12,0,0,0,3.514,20.485,12,12,0,0,0,20.485,3.515Zm.784,13.609H17.757a15.793,15.793,0,0,0,.82-4.421h3.993A10.515,10.515,0,0,1,21.269,17.124ZM12,22.49A9.953,9.953,0,0,1,8.369,18.53H15.63A9.953,9.953,0,0,1,12,22.49ZM7.733,17.124a14.3,14.3,0,0,1-.9-4.421H17.169a14.3,14.3,0,0,1-.9,4.421ZM1.43,12.7H5.423a15.793,15.793,0,0,0,.82,4.421H2.731A10.515,10.515,0,0,1,1.43,12.7Zm1.3-5.827H6.243a15.793,15.793,0,0,0-.82,4.421H1.43a10.515,10.515,0,0,1,1.3-4.421ZM12,1.51A9.953,9.953,0,0,1,15.63,5.47H8.369A9.953,9.953,0,0,1,12,1.51Zm4.266,5.366a14.3,14.3,0,0,1,.9,4.421H6.83a14.3,14.3,0,0,1,.9-4.421Zm6.3,4.421H18.577a15.793,15.793,0,0,0-.82-4.421h3.512A10.515,10.515,0,0,1,22.569,11.3ZM17.194,5.47a12.449,12.449,0,0,0-2.625-3.748A10.618,10.618,0,0,1,20.336,5.47ZM9.431,1.722A12.449,12.449,0,0,0,6.806,5.47H3.664A10.618,10.618,0,0,1,9.431,1.722ZM6.806,18.53a12.449,12.449,0,0,0,2.625,3.748A10.618,10.618,0,0,1,3.664,18.53Zm7.763,3.748a12.451,12.451,0,0,0,2.625-3.748h3.142a10.618,10.618,0,0,1-5.767,3.748Zm0,0",
    transform: "translate(11.534 12.4)",
    fill: "#feffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.ed4cc70ae9c4aacb3451af4566ad16aa.svg";
export { ForwardRef as ReactComponent };